export default {
  advertisements_count: 0,
  promos_count: 0,
  discount_beer: 4,
  discounts_x_amount: [],
  special_price_products: [],
}